import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.341 14.283c0-1.227 1.007-2.222 2.25-2.222 1.241 0 2.248.995 2.248 2.222 0 1.228-1.007 2.223-2.249 2.223s-2.249-.995-2.249-2.223"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.667 14.283c0-3.591 0-5.387 1.13-6.503 1.128-1.116 2.946-1.116 6.58-1.116h6.426c3.635 0 5.453 0 6.582 1.116s1.129 2.911 1.129 6.503 0 5.388-1.13 6.504c-1.128 1.115-2.946 1.115-6.58 1.115h-6.426c-3.635 0-5.453 0-6.582-1.116-1.129-1.115-1.129-2.911-1.129-6.503m6.747 0c0-2.279 1.87-4.127 4.176-4.127s4.177 1.848 4.177 4.127-1.87 4.127-4.177 4.127-4.176-1.847-4.176-4.127m-3.856 2.54c0 .526.432.952.964.952a.96.96 0 0 0 .964-.952v-5.08a.96.96 0 0 0-.964-.952.96.96 0 0 0-.964.953zm15.1.952a.96.96 0 0 1-.963-.952v-5.08c0-.525.431-.952.963-.952.533 0 .964.427.964.953v5.079a.96.96 0 0 1-.964.952",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.42 21.633q.026.301.063.579c.156 1.143.489 2.105 1.262 2.87q.165.162.343.3c.753.685 1.687.99 2.786 1.135 1.114.148 2.53.148 4.288.148h6.567c1.758 0 3.174 0 4.288-.148 1.157-.153 2.131-.482 2.905-1.247.773-.764 1.106-1.726 1.261-2.87.15-1.1.15-2.5.15-4.236v-.14c0-1.736 0-3.136-.15-4.237-.155-1.143-.488-2.106-1.261-2.87a4 4 0 0 0-.343-.3c-.754-.686-1.688-.99-2.786-1.136a12 12 0 0 0-.546-.06c.266 1.112.266 2.646.266 4.865 0 3.591 0 5.387-1.129 6.503s-2.947 1.116-6.582 1.116h-6.425c-2.269 0-3.83 0-4.957-.272",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }